import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { Currency, SpinnerProps } from '@/data/currencies/type';

interface Props {
  readonly currency: Currency;
}

export const CurrencyItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { currency } = props;
  const IconComponent = React.useMemo(
    ():
      | React.FunctionComponent<React.SVGProps<SVGSVGElement>>
      | React.FunctionComponent<SpinnerProps> => currency.icon,
    [currency.icon],
  );

  return (
    <Box sx={styles.container} aria-label={currency.name}>
      <IconComponent width={undefined} height={16} />
      <Typography fontSize={16} fontWeight={400} textTransform="none" whiteSpace="nowrap">
        {currency.name}
      </Typography>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    role: 'button',
    alignItems: 'center',
    gap: 0.5,
    height: 32,
    borderRadius: 16,
    px: 1,
    backgroundColor: 'custom.OffWhite',
    borderColor: 'custom.DividerLight',
    borderStyle: 'solid',
    borderWidth: 1,
  },
};
